import React, { useContext, useEffect } from 'react';
import { InformationOutline, Refresh } from 'pcln-icons';
import { Button, GenericBanner, Flex, Text } from 'pcln-design-system';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import analytics from '../../analytics';
/**
 * ErrorComponent
 * @public
 */
const TryAgain = ({
  lastMessage
}) => {
  useEffect(() => {
    analytics.log({
      message: `TryAgain-component: ${lastMessage}`,
      source: 'TryAgain'
    });
  }, [lastMessage]);
  const {
    setOpenErrorComponent
  } = useContext(ChatbotDataContext);
  const tryAgainHandler = function () {
    setOpenErrorComponent(false);
  };
  return React.createElement(Flex, {
    flexDirection: 'column',
    justifyContent: 'center'
  }, React.createElement(GenericBanner, {
    mx: 3,
    my: 3,
    p: 2,
    borderRadius: 'lg',
    colorScheme: 'warningLight',
    iconLeft: React.createElement(InformationOutline, null),
    text: React.createElement(Text, {
      textStyle: 'subheading6'
    }, "I'm having some trouble coming up with a response right now.")
  }), React.createElement(Flex, {
    justifyContent: 'center',
    pb: 3
  }, React.createElement(Button, {
    size: 'medium',
    color: 'background',
    variation: 'subtle',
    onClick: tryAgainHandler
  }, React.createElement(Refresh, {
    size: 24,
    color: 'primary'
  }), React.createElement(Flex, {
    pl: 2
  }, React.createElement(Text.span, {
    color: 'primary.base',
    bold: true,
    size: 14
  }, "Try Again")))));
};
export default TryAgain;